import { BasicDataNode, DataNode } from 'antd/es/tree';
import { GridDataProps } from '../components/common/GridListView/GridListView';
import { DefaultColumns, DefaultGridElement, ItemsPagination, OperatorsDetail, RedlineConfigValues } from './CommonModel';
import { GraphicActionType, GraphicPageMode } from './GraphicModel';

export type VisualObjectsTreeNode = { vdoItem: VDOItem } & BasicDataNode & DataNode;

export enum VDOItem {
	Text,
	Picture,
	Signature,
	BarCode,
	MagStripe,
}

export type BadgeStudioFilterBy = {
	DoubleSided: boolean;
	OperatorName: OperatorsDetail[];
	Portrait: boolean;
	Landscape: boolean;
	Status?: BadgeStudioStatus;
};

export type BadgeListInfo = {
	Id: number;
	PreviewImage: string;
	Name: string;
	PageOrientation: number;
	DoubleSided: boolean;
	CreatedDate: Date | string;
	LastUpdated: Date | string;
	CreatedBy: string;
	Status: BadgeStudioStatus;
};

export type BadgeListInfoTable = BadgeListInfo & DefaultColumns & Partial<DefaultGridElement>;

export type BadgeListInfoPaginated = {
	BadgesListInfo: BadgeListInfo[];
} & ItemsPagination;

export type BadgeListInfoGrid = GridDataProps<BadgeListInfo>;

export enum BadgeStudioSortOptions {
	Name = 0,
	LastUpdated = 1,
	CreatedBy = 2,
}

export enum BadgeStudioStatus {
	NA = 0,
	New = 1,
	Archived = 2,
}

export enum PageSizeTypeExtended {
	None,
	Letter,
	Folio,
	Legal,
	Tabloid,
	EdgeToEdge,
	WhiteBorder,
}

export type CanvasInfo = {
	isMaps: boolean;
	containerId: string;
	mainContainerId: string;
	viewMode: GraphicPageMode;
	redlineConfiguration: RedlineConfigValues;
	graphicActionType: GraphicActionType;
	disableOptions: boolean;
};

export enum BadgeSide {
	Front,
	Back,
}
